(function () {
  'use strict';
  const root = document.querySelector('[data-vivalle-search]');
  if (!root) return;
  const form = root.querySelector('form');
  if (!form) return;
  const lang = root.dataset.lang;
  const ar = lang === 'ar';
  const strings = JSON.parse(root.querySelector('[data-order-strings]').textContent);
  const phone = form.elements.phone;
  const status = form.querySelector('[role=status]');
  const submit = form.querySelector('[type=submit]');
  const total = form.querySelector('[data-total]');
  const success = root.querySelector('[data-order-success]');
  let sending = false;
  let completed = false;
  const params = new URLSearchParams(location.search);
  const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','ttclid','gclid','gbraid','wbraid'];
  let context = Object.fromEntries(keys.map(k => [k,(params.get(k) || '').slice(0,255)]));
  if ((context.gclid || context.gbraid || context.wbraid) && !context.utm_source) { context.utm_source = 'google'; context.utm_medium = 'cpc'; }
  let previous;
  try { previous = JSON.parse(sessionStorage.getItem('vivalle_traffic_session') || 'null'); } catch (_) {}
  if (!keys.some(k => context[k]) && previous && Date.now() - previous.recordedAt < 1800000) context = previous;
  else context = { ...context, landing_page: location.href.slice(0,2048), referrer: document.referrer.slice(0,2048), recordedAt: Date.now() };
  try { sessionStorage.setItem('vivalle_traffic_session',JSON.stringify(context)); } catch (_) {}
  delete context.recordedAt;
  root.querySelectorAll('[data-language-link]').forEach(a => {
    const target = new URL(a.href,location.origin);
    for (const k of keys) if (context[k]) target.searchParams.set(k,context[k]);
    a.href = target.href;
  });
  const normalize = v => v.trim().replace(/[٠-٩]/g,d=>'٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/[۰-۹]/g,d=>'۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/[\s().\-\u200e\u200f\u061c]/g,'').replace(/^(?:\+?212|00212)0?([67]\d{8})$/,'0$1');
  const cookie = name => { const row = document.cookie.split('; ').find(s=>s.startsWith(name+'=')); try { return row ? decodeURIComponent(row.slice(name.length+1)) : ''; } catch (_) { return ''; } };
  const selected = () => form.querySelector('input[name=programme]:checked');
  form.querySelectorAll('input[name=programme]').forEach(input => input.addEventListener('change',()=>{total.textContent=input.dataset.price + (ar?' درهم':' MAD');status.textContent='';}));
  phone.addEventListener('input',()=>phone.setCustomValidity(''));
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    if (sending || completed) return;
    const number = normalize(phone.value);
    phone.setCustomValidity(/^0[67]\d{8}$/.test(number)?'':strings.invalid);
    if (!form.reportValidity()) return;
    const offer = selected();
    if (!offer) return;
    sending = true; submit.disabled = true; submit.textContent = strings.sending; status.textContent = '';
    const eventId = 'purchase_'+Date.now()+'_'+Math.random().toString(36).slice(2,10);
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(),60000);
    try {
      const response = await fetch('/apps/vivalle-order',{method:'POST',credentials:'same-origin',signal:controller.signal,body:new URLSearchParams({...context,name:'Client Vivalle - a confirmer',city:'A confirmer',phone:number,programme:offer.value,offer:offer.dataset.count,website:form.elements.website.value,fbp:cookie('_fbp'),fbc:cookie('_fbc'),user_agent:navigator.userAgent,page_url:location.href,lead_event_id:eventId})});
      const data = await response.json();
      if (!response.ok || data.ok !== true || !data.orderName) throw new Error('Unconfirmed order');
      completed = true; form.hidden = true; success.hidden = false; success.focus();
      const detail = {value:Number(offer.dataset.price),currency:'MAD',content_name:'Vivalle x'+offer.dataset.count,content_type:'product',content_id:offer.dataset.sku,quantity:1,price:Number(offer.dataset.price),event_id:eventId,transaction_id:String(data.orderName)};
      try { if (typeof window.Shopify?.analytics?.publish === 'function') Promise.resolve(window.Shopify.analytics.publish('vivalle:order_confirmed',detail)).catch(()=>{}); } catch (_) {}
      document.dispatchEvent(new CustomEvent('vivalle:order-confirmed',{detail}));
    } catch (_) { status.textContent = strings.error; }
    finally { clearTimeout(timer);sending=false;if(!completed){submit.disabled=false;submit.textContent=strings.submit;} }
  });
  const sticky = root.querySelector('.vs-sticky');
  if (sticky && 'IntersectionObserver' in window) new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting;},{threshold:0.05}).observe(root.querySelector('#commander'));
})();
